/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
var locale = localStorage.getItem('lang') || 'zh_CN';
var i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: locale,
  messages: {
    zh_CN: Object.assign(require('./zh.json')),
    en_GB: Object.assign(require("./en.json"))
  }
});
export default i18n;